<footer>
  <div [@animateFooter]>
    <ul class="footer-left-bar d-none d-md-block">
      <li>
        <a
          (click)="
            analyticsService.sendAnalyticEvent(
              'click_github',
              'footer',
              'github'
            )
          "
          href="https://github.com/Basitkh12"
          target="_blank"
        >
          <i class="fab fa-github"></i>
        </a>
      </li>
      <li>
        <a
          (click)="
            analyticsService.sendAnalyticEvent(
              'click_linkedin',
              'footer',
              'github'
            )
          "
          href="https://www.linkedin.com/in/abdul-basit-aa8942236/"
          target="_blank"
        >
          <i class="fab fa-linkedin-in"></i>
        </a>
      </li>
    </ul>
    <div class="footer-right-bar d-none d-md-block">
      <a
        (click)="
          analyticsService.sendAnalyticEvent(
            'click_send_mail',
            'footer',
            'email'
          )
        "
        href="mailto:basitk365gmail.com"
        target="_blank"
        >basitk365gmail.com
      </a>
    </div>
  </div>

  <div class="footer-credits text-center">
    <a
      (click)="
        analyticsService.sendAnalyticEvent(
          'click_github_portfolio_andresjose',
          'footer',
          'click'
        )
      "
      href="https://github.com/Basitkh12"
      target="_blank"
      rel="nofollow noopener noreferrer"
    >
      <div>Built by Abdul Basit Tanveer</div>
    </a>
    <a
      (click)="
        analyticsService.sendAnalyticEvent(
          'click_github_portfolio_brittany',
          'footer',
          'click'
        )
      "
      target="_blank"
      rel="nofollow noopener noreferrer"
    >
    </a>
  </div>
</footer>
